import { StatusPillAppearance } from '@lyearn/ui/dist/esm/Pill/StatusPill/types';
import { JobEntityStatusEnum, ResourceStatusEnum } from '@/types/schema';

export const RESOURCE_STATUS_PILL_CONFIG: {
  [key in string]: {
    appearance: StatusPillAppearance;
    key: string;
  };
} = {
  [ResourceStatusEnum.Draft]: {
    appearance: 'primary',
    key: 'Admin:Status.DRAFT',
  },
  [ResourceStatusEnum.UnpublishedChanges]: {
    appearance: 'purple',
    key: 'Admin:Status.UNPUBLISHED_CHANGES',
  },
  [JobEntityStatusEnum.Failed]: { appearance: 'danger', key: 'Admin:Status.FAILED' },
  [ResourceStatusEnum.Archived]: { appearance: 'secondary', key: 'Common:Filter.Archived' },
  [ResourceStatusEnum.Revoked]: { appearance: 'secondary', key: 'Common:Filter.Revoked' },
  [ResourceStatusEnum.Published]: { appearance: 'secondary', key: 'Common:Filter.Published' },
  [ResourceStatusEnum.Closed]: { appearance: 'secondary', key: 'Common:Filter.Closed' },
};
